<script setup>
/**
 * This component will only render if the app is within a webview, as determined by the composable.
 */

import { useWebViewContext } from '../../composables/webview-context';

const { isWebView } = useWebViewContext();
</script>

<template>
    <div v-if="isWebView">
        <slot/>
    </div>
</template>
